import { LocalDate } from '@brunommsilva/react-foundations';

import { TransactionType } from '../../../models/transactions';

export type FilterFields = {
  dateFrom?: LocalDate;
  dateTo?: LocalDate;
  type?: TransactionType;
  category?: {
    id: string;
    name: string;
    icon?: string;
  };
  account?: {
    id: string;
    name: string;
  };
  description?: string;
};

export class TransactionsFilter {
  dateFrom?: LocalDate;
  dateTo?: LocalDate;
  type?: TransactionType;
  category?: {
    id: string;
    name: string;
    icon?: string;
  };
  account?: {
    id: string;
    name: string;
  };
  description?: string;

  constructor(data?: FilterFields) {
    this.dateFrom = data?.dateFrom;
    this.dateTo = data?.dateTo;
    this.type = data?.type;
    this.category = data?.category;
    this.account = data?.account;
    this.description = data?.description;
  }

  public clone(data: FilterFields = {}): TransactionsFilter {
    return new TransactionsFilter({
      dateFrom: 'dateFrom' in data ? data.dateFrom : this.dateFrom,
      dateTo: 'dateTo' in data ? data.dateTo : this.dateTo,
      type: 'type' in data ? data.type : this.type,
      category: 'category' in data ? data.category : this.category,
      account: 'account' in data ? data.account : this.account,
      description: 'description' in data ? data.description : this.description,
    });
  }

  public hasFilter(): boolean {
    return !!(
      this.account?.id ||
      this.category?.id ||
      this.type ||
      this.dateFrom ||
      this.dateTo ||
      this.description
    );
  }
}
